import React from 'react';
import { FormItem as Item, Input, InputNumber } from 'formik-antd';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input as InputAntd, InputNumber as InputAntdNumber } from 'antd';
import styled from 'styled-components';
import { Field } from 'formik';

const StyledItem = styled(Form.Item)`
	.ant-input {
		width: ${({ width }) => width || '100%'};
	}
`;
const FormItem = styled(Item)`
	&& {
		margin-bottom: ${({ mb }) => mb || '1em'};
		display: ${({ isUploadForm }) => isUploadForm && `flex`};
		flex-direction: ${({ isUploadForm }) => isUploadForm && `column`};
		.ant-input-number,
		input {
			width: 100%;
		}
		.ant-input-prefix {
			color: rgba(0, 0, 0, 0.25);
		}
		.ant-form-item-label {
			label {
				font-size: ${({ reverse }) => reverse && '11px'};
				color: ${({ reverse }) => reverse && '#bbb'};
				text-transform: ${({ reverse }) => reverse && 'uppercase'};
				line-height: ${({ reverse }) => reverse && '1.4'};
				font-weight: ${({ reverse }) => reverse && '600'};
				float: ${({ isUploadForm }) => isUploadForm && `left`};
				font-size: ${({ isUploadForm }) => isUploadForm && '14px'};
				line-height: ${({ isUploadForm }) => isUploadForm && '1.4'};
			}
			label {
				font-size: ${({ label }) => label && "15px"};
				line-height: ${({ label }) => label && "1.5"};
			}
		}
		.help-text {
			font-size: 12px;
			color: #999;
		}
	}
`;

const StyledTextarea = styled(Input.TextArea)`
	&& {
		border: ${({ transparent }) => transparent && 'none'};
		padding-left: ${({ transparent }) => transparent && 0};
		resize: none;
		&:focus {
			border: ${({ transparent }) => transparent && 'none'};
			box-shadow: ${({ transparent }) => transparent && 'none'};
		}
	}
`;

export const SpecialComponent = ({ field, helpText, ...props }) => {
	field.value = props.value;
	return (
		<StyledItem
			{...field}
			{...props}
			value={props.value}
			validateStatus={props.error && 'error'}
			help={props.error && props.error}
			label={props.label}>
			<InputAntd {...field} {...props} value={props.value} onChange={props.onChange} id={props.id} onPressEnter={() => null} />
			{helpText && <span className="help-text grey">{helpText}</span>}
		</StyledItem>
	);
};

function TextInput({ helpText, independent, special, name, label, isUploadForm, ...props }) {
	let Inputee = independent ? InputAntd : Input;

	let InputeeNumber = independent ? InputAntdNumber : InputNumber;

	if (special) return <Field {...props} helpText={helpText} id={props.id} name={name} component={SpecialComponent} />;

	if (independent) {
		if (props.number)
			return (
				<Form.Item name={name} label={label}>
					<InputAntdNumber {...props} name={name} style={{ width: '100%' }} />
				</Form.Item>
			);

		if (props.textarea)
			return (
				<Form.Item name={name} label={label}>
					<InputAntd.TextArea {...props} name={name} style={{ width: '100%' }} />
				</Form.Item>
			);

		return (
			<Form.Item help={props.error} validateStatus={props.error && 'error'} name={name} label={label} onPressEnter={props.onPressEnter}>
				<InputAntd {...props} name={name} style={{ width: '100%' }} />
			</Form.Item>
		);
	}
	return (
		<FormItem
			name={name}
			style={props.style}
			reverse={props.reverse || 0}
			isUploadForm={isUploadForm}
			extra={props.extra}
			label={label}
			mb={props.mb}
			className={props.className}>
			{props.textarea ? (
				<>
					<StyledTextarea {...props} name={name} />
					{helpText && <span className="help-text">{helpText}</span>}
				</>
			) : props.password ? (
				<>
					<Inputee.Password {...props} name={name} />
					{helpText && <span className="help-text">{helpText}</span>}
				</>
			) : props.number ? (
				<>
					<InputeeNumber {...props} name={name} style={{ width: '100%' }} />
					{helpText && <span className="help-text">{helpText}</span>}
				</>
			) : (
				<>
					<Inputee {...props} name={name} />
					{helpText && <span className="help-text">{helpText}</span>}
				</>
			)}
		</FormItem>
	);
}

export default TextInput;
